export default __webpack_public_path__ + "fdaf701df3d664c808819ce2a9d4ad4d.png";